import React from "react";
import NtkHeader from "../common/NtkHeader";
import NtkParagraph from "../common/NtkParagraph";
import NtkButton from "../common/NtkButton";
import { Grid } from "@material-ui/core";
const StartLearning = ({ header, paragraph, title }) => (
  <>
    <Grid style={{ textAlign: "center" }}>
      <NtkHeader header={header} />
    </Grid>
    <NtkParagraph paragraph={paragraph} />
    <Grid
      container
      style={{ justifyContent: "center", margin: "3em auto 5em auto" }}
    >
      <NtkButton title={title} />
    </Grid>
  </>
);

export default StartLearning;
